<template lang="pug">
.form-control.buttons-control
  div.form-control-buttons(v-if="toggleButton")
    Button(
      v-for="prop in items" 
      :key="prop.value" 
      :label="prop.label" 
      @click="setSelected(prop.value)" 
      :class="{'p-button-outlined': selected !== prop.value}"
      :disabled="prop.disabled"
    )
      template(#default v-if="prop.content")
        .button-content(v-safe-html="prop.content")
  div.form-control-radio-buttons(v-else) 
    div.radio-content(v-for="prop in items" :key="prop.value" )
      RadioButton(
        v-model="selectedProxy"
        :id="prop.value"
        :value="prop.value"
        @click="setSelected(prop.value)"
        :disabled="prop.disabled"
      )
      label(v-if="!prop.content" :for="prop.value") {{ prop.label }}
      label(v-else :for="prop.value" v-safe-html="prop.content")
</template>

<script lang="ts">
import { ref, computed, PropType, defineComponent } from "vue";
import { storeToRefs } from "pinia";
import { useSettings } from "@/store";
import RadioButton from "primevue/radiobutton";
import Button from "primevue/button";
import { SelectionButtonsItem } from "@/types";

export default defineComponent({
  name: "SelectionsButtons",
  components: {
    Button,
    RadioButton,
  },
  props: {
    items: {
      type: Array as PropType<SelectionButtonsItem[]>,
      default: () => [],
    },
    modelValue: {
      type: null,
      required: true,
    },
  },
  emits: ["update:modelValue", "select"],
  setup(props, { emit }) {
    const { settings } = storeToRefs(useSettings());
    const toggleButton = computed(() =>
      settings.value?.formOptions?.formToggleButton
        ? settings.value?.formOptions?.formToggleButton
        : false
    );

    const selected = computed({
      get() {
        return props.modelValue;
      },
      set(value) {
        emit("update:modelValue", value);
      },
    });

    const selectedProxy = ref(props.modelValue);

    function setSelected(value: unknown) {
      selectedProxy.value = value;
      emit("select", value);
      emit("update:modelValue", value);
    }

    return {
      toggleButton,
      selectedProxy,
      setSelected,
      selected,
    };
  },
});
</script>

<style scoped>
.form-control.buttons-control .form-control-radio-buttons {
  padding-left: 2rem;
  gap: 1.5rem;
  label {
    padding-left: 0.5rem;
  }
}
.button-content {
  width: 100%;
  text-align: center;
}
</style>
